import { render, staticRenderFns } from "./bindDialog.vue?vue&type=template&id=d0a90a0c&scoped=true&"
import script from "./bindDialog.vue?vue&type=script&lang=js&"
export * from "./bindDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a90a0c",
  null
  
)

export default component.exports